import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { removeToken } from '@/utils/auth'
import { getUserInfo, userLogout } from '@/apiFzn'
import type { IUserInfoType } from '@/apiFzn/types'

export const useUserStore = defineStore('user', () => {
  // 用户信息
  const userInfo = ref<IUserInfoType>()

  /** 是否登录 */
  const isLogin = computed(() => {
    return !!userInfo.value
  })

  /** 用户退出登录 */
  const userLogoutHandler = async () => {
    // 退出登录
    await userLogout()
    // 删除token
    removeToken()
  }

  /** 获取用户信息 */
  const getUserInfoHandler = async () => {
    const res = await getUserInfo()
    userInfo.value = res.user
    return userInfo.value
  }

  return { userInfo, isLogin, userLogoutHandler, getUserInfoHandler }
})
